import { Component, Vue, Prop } from "vue-property-decorator";

enum Variant {
  Success = "success",
  Danger = "danger",
  Warning = "warning",
  Default = "default",
  Transparent = "transparent"
}

@Component
export default class ButtonsMixin extends Vue {
  @Prop({ default: "button" })
  private tag!: any;

  @Prop({ default: Variant.Success })
  private variant!: Variant;

  @Prop({ default: false })
  private rounded!: boolean;

  @Prop({ default: false })
  private disabled!: boolean;
}
